// Chrome shared by the static pages — the landing page at / and CLEAR
// Levels at /levels/: the wordmark, the arrow glyph used in links, and the
// site footer. Kept out of Landing.tsx so the pages cannot drift apart.
import { APP_VERSION, BUILDER_URL, LANDING_URL, LEVELS_URL, TAGLINE } from '../ui/brand.ts';

export const BISG_STANDARD_URL = 'https://knowledgecenter.bisg.org/226a2o7/';
export const HUGO_URL = 'https://hugo-prototype.netlify.app/';

/** The CLEAR wordmark drawn in CSS/SVG so it reads on dark backgrounds. */
export function Wordmark() {
  return (
    <span className="wordmark" aria-label="CLEAR">
      <svg className="wordmark-mark" viewBox="0 0 24 24" aria-hidden="true">
        <rect width="24" height="24" rx="2" fill="#00c3b2" />
        <path d="M5.5 12.5l4.5 4.5 9-10" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="wordmark-text" aria-hidden="true">
        CLEAR
      </span>
    </span>
  );
}

export function ArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

export function SiteFooter() {
  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-brand">
          <Wordmark />
          <p>{TAGLINE}</p>
        </div>
        <nav className="lp-footer-links" aria-label="Footer">
          <a href={BUILDER_URL}>Statement Builder</a>
          <a href={`${LANDING_URL}#what`}>What CLEAR is</a>
          <a href={LEVELS_URL}>CLEAR Levels</a>
          <a href={`${LANDING_URL}#privacy`}>Privacy</a>
          <a href={BISG_STANDARD_URL} rel="noreferrer">
            BISG standard
          </a>
          <a href={HUGO_URL} rel="noreferrer">
            Hugo prototype
          </a>
        </nav>
        <p className="lp-footer-fine">
          CLEAR Statement Builder {APP_VERSION}. Not an official BISG product. Not a certification tool. Not
          a production accounting system.
        </p>
      </div>
    </footer>
  );
}
